import request from "@/utils/request";

export async function getChannelList(postData) {
  return await request({
    url: '/generic-record/list',
    method: "post",
    data: postData,
  });
}